import React from 'react';
import { Box, Typography } from '@mui/material';
import { infoCardStyles } from './InfoCard.styles';

const InfoCard = ({ title, subtitle }) => {
  const styles = infoCardStyles();

  return (
    <Box sx={styles.card}>
      <Typography sx={styles.heading} mb={{xs: "10px", lg: "15px"}}>{title}</Typography>
      <Typography sx={styles.subtitle}>{subtitle}</Typography>
    </Box>
  );
};

export default InfoCard;

